import { Localisation } from "../libs/Localisation";
import App from "../main";

export default class Tutorial extends Phaser.Scene {
    constructor() {
        super('Tutorial');
    }

    create() {
        var reference = this.add.image(App.MAX_WIDTH_HALF, App.MAX_HEIGHT_HALF, 'bob')
        reference.visible = false;
        this.cameras.main.startFollow(reference);
        this.resize(this.scale.gameSize);

        this.setAnims();
        this.add.sprite(App.MAX_WIDTH_HALF + 0.75 * 250, App.MAX_HEIGHT_HALF + 0.75 * 200, 'hand').setScale(0.75).play('hand');
        var tapToDrop = this.add.text(App.MAX_WIDTH_HALF, App.MAX_HEIGHT_HALF + 0.75 * 800, Localisation.TEXTS.GAME_TAP_TO_DROP_TEXT[App.langIndex], { fontFamily: 'FredokaOne', fontSize: '160px', fontStyle: 'bold', fill: '#712E3A',strokeThickness: 16,align:'center',wordWrap: { width: 1200, useAdvancedWrap: true } }).setOrigin(0.5, 0.5).setShadow(2, 2, "#00000", 2, true, false);

        this.tweens.add({
            targets: tapToDrop,
            duration: 600,
            scale: 0.75,
            yoyo: true,
            loop: -1
        });
    }

    setAnims() {
        this.anims.create({
            key: 'hand',
            frames: this.anims.generateFrameNames('hand'),
            frameRate: 48,
            repeat: -1
        })
    }

    private resize(gameSize?: any) {
        this.cameras.main.width = gameSize.width;
        this.cameras.main.height = gameSize.height;
    }
}